import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import "../assets/icons/iconfont.js"

Vue.use(Element)

var eventBus = {
    install(Vue, options) {
        Vue.prototype.$bus = new Vue();
    }
};
Vue.use(eventBus);